"use client";

import { type ReactNode } from "react";

import { type Mode } from "@demo/constants/mode";
import { useMode } from "@demo/hooks/useMode";

const ModeGate = ({ mode, children }: { mode: Mode | Mode[]; children: ReactNode }) => {
  const [active] = useMode();
  const allowed = Array.isArray(mode) ? mode : [mode];
  return allowed.includes(active) ? <>{children}</> : null;
};

export default ModeGate;
